import React from 'react'
import { Route } from 'react-router-dom'
import Roles from '../../../../views/Dashboard/Management/RolesManagement'

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <div>
    {/* Redirect if exact matched */}
    <Route path={match.path} component={Roles} />
  </div>
)
